import styled, { css } from 'styled-components';

import { Icon as SemanticIcon } from 'semantic-ui-react';
import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Main = styled.div`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px;
  max-width: 450px;
  padding-bottom: 10px;
  width: auto;
  padding-bottom: calc(60px + 2%);
`;

const Heading = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  margin: 0 25px;
  text-align: center;
`;

const SubHeading = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 13px;
  margin: 10px 0;
  text-align: center;
`;

const Text = styled(TextLayoutComponent)``;

const TextHeader = styled(TextLayoutComponent.Header)`
  font-size: 18px;
`;

const SmallText = styled(TextLayoutComponent)`
  font-size: 10px;
  margin-bottom: 10px;
`;

const SignUpButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    min-width: 100px;
  }
`;

const PaymentMethodContainer = styled.div`
  margin-bottom: 20px;

  div:first-of-type {
    margin-top: 5px;
  }
`;

const FullWidth = styled.div`
  width: 100%;
  align-items: center;
`;

const FixedButtonContainer = styled.div`
  background-color: ${(props) => props.theme.color.background};
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  ${(props) => css`
    -webkit-box-shadow: 0px -5px 7px -6px ${props.theme.color.sidebarBorder};
    box-shadow: 0px -5px 7px -6px ${props.theme.color.sidebarBorder};
    border-top: 1px solid ${props.theme.color.sidebarBorder};
  `}

`;

const ErrorMessage = styled(TextLayoutComponent.Error)`
  :first-child {
    margin-top: 40px;
    margin-bottom: 20px;
    text-align: center;
  }
`;

const WrapperCountry = styled.div`
    position: relative;
`;

const Icon = styled(SemanticIcon)`
  position: absolute;
  top: 50%;
  right: -40px;
  &&&{
    margin: 0;
  }
`;

export {
  ErrorMessage,
  FullWidth,
  Heading,
  Main,
  PaymentMethodContainer,
  SignUpButton,
  SmallText,
  SubHeading,
  Text,
  TextHeader,
  FixedButtonContainer,
  WrapperCountry,
  Icon,
};
